import styled from 'styled-components';
import { UploaderLayout } from '../Modules/UploaderLayout';
import { InlineUploaderLayout } from '../InlineUploaderLayout';
import ContentLayout from './ContentLayout';

const BrandingContentWrapper = styled(ContentLayout.ContentPadded)`
  ${UploaderLayout.Description} {
    max-width: 470px;
    min-width: 210px;
  }
  ${UploaderLayout.FlexWrapper} {
    max-width: 470px;
    min-width: 210px;
  }
  ${UploaderLayout.Title} {
    font-size: var(--font-size-heading-4);
    line-height: var(--font-line-height-regular);
  }
`;

const LegalContentWrapper = styled(ContentLayout.ContentPadded)`
  ${UploaderLayout.Title}, ${InlineUploaderLayout.Title} {
    font-size: var(--font-size-heading-4);
    line-height: var(--font-line-height-regular);
  }
`;

const SettingsLayout = {
  BrandingContentWrapper,
  LegalContentWrapper
};

export default SettingsLayout;
